<mat-dialog-content>
  <div class="course_type_popup_overlay">
    <div class="course_type_opup">
      <div class="course_type_title">Choose course type<a class="material-icons" mat-dialog-close>close</a></div>
      <div class="course_type">
          <div class="course_box" [ngClass]="{'active': selectedCourse === courseTypeDetails.GeneralCourseTypeId}" (click)="updateSelectedCourseType(courseTypeDetails.GeneralCourseTypeId)">
            <div class="course_img"><img src="../../../../assets/images/top-icon/course-type.svg" alt=""></div>
            <div class="course_type_text">General</div>
          </div>
          <div class="course_box" [ngClass]="{'inactive': !eflCoursesAvailability, 'active': selectedCourse === courseTypeDetails.EFLCourseTypeId}" (click)="updateSelectedCourseType(courseTypeDetails.EFLCourseTypeId)">
            <div class="course_img"><img src="../../../../assets/images/top-icon/course-type.svg" alt=""></div>
            <div class="course_type_text">English as a Foreign Language (EFL)</div>
          </div>
      </div>
      <div class="buttons_sec">
       <div class="btn_group">
          <button class="cancel_btn" mat-dialog-close="true">Cancel</button>
          <button (click)="createNewCourse()" class="save_btn" mat-stroked-button mat-dialog-close="true">Choose</button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
